import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingClientOptions, OrderListTableField } from 'cloud-shared-lib';
import { ApiLinks as CSLApiLinks } from 'projects/cloud-shared-lib/src/lib/modules/cutting-panel-list/csl.api-links';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ClientOptionService {
  private clientOptions: CuttingClientOptions;

  constructor(private http: HttpClient) {}

  getClientOptions(): Observable<CuttingClientOptions> {
    if (this.clientOptions) {
      return of(this.clientOptions);
    }

    return this.http.get<CuttingClientOptions>(ApiLinks.clientOptions).pipe(tap(res => (this.clientOptions = res)));
  }

  saveOrderTableFieldSettings(orderTableFields: OrderListTableField[]): Observable<OrderListTableField[]> {
    return this.http
      .put<OrderListTableField[]>(CSLApiLinks.clientOptions + '/order-table-fields', orderTableFields)
      .pipe(tap(res => (this.clientOptions.orderTableFields = res)));
  }

  clearClientOptions(): void {
    this.clientOptions = null;
  }
}
